import { render, staticRenderFns } from "./TheNavMenu.vue?vue&type=template&id=896e160e&scoped=true&"
import script from "./TheNavMenu.vue?vue&type=script&lang=js&"
export * from "./TheNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheNavMenu.vue?vue&type=style&index=0&id=896e160e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e160e",
  null
  
)

export default component.exports